import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_PREFIX, BASE_URL } from '@CONSTANTS/API.constant';
import userRepository from '@REPOSITORIES/local-repository/user-repository';
import { 
    SystemSettings, 
    SystemSettingsApiResponse,
} from '@INTERFACES/api/system-settings';

function transformSystemSettingsResponse(raw: SystemSettingsApiResponse): SystemSettings {
    return {
        id: raw.id,
        wysiwygApiToken: raw.wysiwyg_api_token,
        wysiwygApiUrl: raw.wysiwyg_api_url,
        systemName: raw.system_name,
        systemVersion: raw.system_version,
        maintenanceMode: raw.maintenance_mode,
        maintenanceMessage: raw.maintenance_message,
        createdAt: raw.created_at,
        updatedAt: raw.updated_at,
    };
}

export const systemSettingsApi = createApi({
    reducerPath: 'system-settings-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    tagTypes: ['SystemSettings'],
    endpoints: (builder) => ({
        getSystemSettings: builder.query<SystemSettings, void>({
            query: () => '/system-settings/',
            transformResponse(raw: SystemSettingsApiResponse) {
                return transformSystemSettingsResponse(raw);
            },
            providesTags: ['SystemSettings'],
        }),
    }),
});

export const { useGetSystemSettingsQuery } = systemSettingsApi; 